import React from 'react';
import { WrapperItem } from '../components/wrapper-item';
import { Column } from '../components/column';
import { Section } from '../components/section';
import { Table } from '../components/table';
import { Divider } from '../components/divider';
import { shorthand } from '../utils/css-utils';
import { useWidth } from '../components/width-context';
import { GenericImage } from './generic-image';
export const SectionDivider = (props) => {
    const { section, cssClass, columnCssClass } = props;
    const { backgroundColor, borderBottom, borderLeft, borderRight, borderTop, dividerImageDesktop, htmlDividerStyles, dividerWidth, dividerHeight, outerPadding, innerPadding, } = section;
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: backgroundColor, borderBottom: borderBottom, borderLeft: borderLeft, borderRight: borderRight, borderTop: borderTop, cssClass: cssClass, padding: shorthand(outerPadding) },
            React.createElement(Column, { padding: shorthand(innerPadding), cssClass: columnCssClass },
                React.createElement(RenderDivider, { htmlDividerStyles: htmlDividerStyles, dividerImageDesktop: dividerImageDesktop, dividerWidth: dividerWidth, dividerHeight: dividerHeight })))));
};
function RenderDivider({ htmlDividerStyles, dividerImageDesktop, dividerWidth, dividerHeight, }) {
    // if we'll allow to drag dividers into the mix section, there will be issues
    // in outlook as it ignores height and images are being streched.
    const { width: availableWidth } = useWidth();
    if (htmlDividerStyles) {
        return (React.createElement(Table, { align: "center", width: htmlDividerStyles.width, padding: "0px" },
            React.createElement("tr", null,
                React.createElement("td", null,
                    React.createElement("div", { style: { lineHeight: '40px' } },
                        React.createElement("div", { style: {
                                display: 'inline-block',
                                width: '100%',
                                borderBottom: htmlDividerStyles.border,
                                verticalAlign: 'middle',
                            } }))))));
    }
    if (!dividerImageDesktop) {
        return React.createElement(Divider, { padding: "0px", borderColor: "#000000", borderWidth: "1px" });
    }
    return (React.createElement(GenericImage, { src: dividerImageDesktop, width: "auto", probableWidth: Math.min(dividerWidth, availableWidth), height: dividerHeight, alt: "", style: { lineHeight: '40px' }, showAfterLoad: false }));
}
//# sourceMappingURL=section-divider.js.map